import { Vault } from '@/features/vaults/types';
import { ethereumTestKeyrock1 } from '@/features/vaults/constants/vaults/keyrock/ethereum-test-keyrock-1';
import { ethereumTestKeyrock2 } from '@/features/vaults/constants/vaults/keyrock/ethereum-test-keyrock-2';
import { ethereumTestKeyrock3 } from '@/features/vaults/constants/vaults/keyrock/ethereum-test-keyrock-3';
import { ethereumTestKeyrock3_2 } from '@/features/vaults/constants/vaults/keyrock/ethereum-test-keyrock-3-2';

export const vaultsStaging: Vault[] = [
  {
    id: 'ethereum-test-mellow-vault',
    type: 'multi-vault',
    name: 'Test Mellow Vault',
    description: 'Test Mellow Vault',
    category: 'restaking',
    address: '0xaD27B49f9e0ca3668eEc306D00E67ef47fcEFEEA',
    curators: [],
    operator: [],
    points: [
      { entity: 'mellow', startTimestamp: 0 },
      { entity: 'symbiotic', startTimestamp: 0 },
    ],
    layer: 'Symbiotic',
    network: 'ethereum',
    depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    additionalTokens: [],
    depositTokens: [
      {
        address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
        decimals: 18,
        symbol: 'STETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
        decimals: 18,
        symbol: 'WSTETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        decimals: 18,
        symbol: 'WETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
      {
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        decimals: 18,
        symbol: 'ETH',
        wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
      },
    ],
    // vault.asset()
    baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    lpTokenSymbol: 'testMV',
    lpTokenDecimals: 18,
    withdrawDuration: 2 * 604800,
    withdrawDurationDisplay: '<2 weeks',
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'base-mellow-test-vault-base',
    type: 'core-vault',
    name: 'MellowTestVaultBase',
    description: 'MellowTestVaultBase',
    category: 'core-vault',
    address: '0x85C205b7Dd8EAd3a288feF72E7e6681E524F1575',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
    network: 'base',
    networks: [
      {
        network: 'base',
        vaultAddress: '0x85C205b7Dd8EAd3a288feF72E7e6681E524F1575',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'MTVB',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
  },
  {
    id: 'ethereum-mellow-test-strategy',
    type: 'core-vault',
    name: 'Mellow test stRATEGY',
    description: 'Mellow tstRATEGY',
    category: 'core-vault',
    address: '0xe3143Cfcfa5cB5e438c64B6EB03087445eEaCCDc',
    curators: ['mellow'],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0xe3143Cfcfa5cB5e438c64B6EB03087445eEaCCDc',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tstRATEGY',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
  },
  // deprecated
  {
    id: 'ethereum-pre-prod-tqeth',
    type: 'core-vault',
    name: '[pre-prod]Theoriq AlphaVault ETH',
    description: 'Theoriq AlphaVault ETH',
    category: 'core-vault',
    address: '0x2669a8B27B6f957ddb92Dc0ebdec1f112E6079E4',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x2669a8B27B6f957ddb92Dc0ebdec1f112E6079E4',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tqETHPreProd',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-alpha-core',
    type: 'core-vault',
    name: 'Alpha Core',
    description:
      'ALPHA is a performance-focused vault maximizing risk-adjusted returns. It allocates capital to high-conviction strategies and builds deep, tradable markets—forming a durable base for sustainable liquidity growth and long-term yield.',
    category: 'core-vault',
    address: '0xBbFff0044990271c2588ee6b9472E547A0111E4e',
    curators: ['alphaping'],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0xBbFff0044990271c2588ee6b9472E547A0111E4e',
      },
    ],
    baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    lpTokenSymbol: 'mAlpha',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'monad-testnet-monad-test-vault',
    type: 'core-vault',
    name: 'Monad Test Vault',
    description: 'Monad Test Vault',
    category: 'core-vault',
    address: '0x8769b724e264D38d0d70eD16F965FA9Fa680EcDe',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'monad-testnet',
    networks: [
      {
        network: 'monad-testnet',
        vaultAddress: '0x8769b724e264D38d0d70eD16F965FA9Fa680EcDe',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tvMON',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(60),
    redeemHandlingInterval: BigInt(60),
    callConfigOrigin: {
      branch: 'deploy/monad-test',
      filenamePrefix: 'monad:mon',
    },
    allocations: {
      showAllocationsTab: false,
    },
  },
  {
    id: 'ethereum-umint-usd',
    type: 'core-vault',
    name: 'uMINT USD',
    description: '',
    category: 'core-vault',
    address: '0xb3023674f16e31A06a97504BEA224fd84dda41E0',
    curators: ['alphaping'],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0xb3023674f16e31A06a97504BEA224fd84dda41E0',
      },
    ],
    baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    lpTokenSymbol: 'umUSD',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    callConfigOrigin: {
      branch: 'deploy/alphaping-umint',
      filenamePrefix: 'ethereum:mAlphaUmint',
    },
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-edge-capital-test',
    type: 'core-vault',
    name: 'EC-Test',
    description: '',
    category: 'core-vault',
    address: '0x3a06B0838fbe48eA54fdB94F9d2E5576E67377D1',
    curators: ['edgecapital'],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x3a06B0838fbe48eA54fdB94F9d2E5576E67377D1',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'ECT',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'ethereum:ECT',
    },
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-reusd-usd',
    type: 'core-vault',
    name: 'reUSD USD',
    description: '',
    category: 'core-vault',
    address: '0x5E0B8E7f6F109CB532AF281d9f6e491829a2A1C4',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x5E0B8E7f6F109CB532AF281d9f6e491829a2A1C4',
      },
    ],
    baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    lpTokenSymbol: 'reUSDUSD',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    callConfigOrigin: {
      branch: 'deploy/alphaping-umint',
      filenamePrefix: 'ethereum:reUSDUSD',
    },
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'ethereum-test-vault',
    type: 'core-vault',
    name: 'Test Vault',
    description: '',
    category: 'core-vault',
    address: '0xC07983aD842AAD331D49A7fcCa837EdDd24FD085',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0xC07983aD842AAD331D49A7fcCa837EdDd24FD085',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tv',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'ethereum:testVault',
    },
    allocations: {
      showAllocationsTab: true,
    },
  },
  {
    id: 'hoodi-test-lido-v3-vault',
    type: 'core-vault',
    name: 'Test Lido V3 Vault',
    description: 'Test Lido V3 Vault',
    category: 'core-vault',
    address: '0xC0bB08E0f2320A5cc1fB5d17a79FFFe5734bd59F',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'hoodi',
    networks: [
      {
        network: 'hoodi',
        vaultAddress: '0xC0bB08E0f2320A5cc1fB5d17a79FFFe5734bd59F',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tsLidoV3',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'hoodi:lidoV3',
    },
    allocations: {
      showAllocationsTab: false,
    },
  },
  {
    id: 'ethereum-reporting-test-vault-1',
    type: 'core-vault',
    name: 'Reporting Test Vault 1',
    description: '',
    category: 'core-vault',
    address: '0xdfEc1c89Ff3b45361D9FFBEc4e45f0eBb2098698',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0xdfEc1c89Ff3b45361D9FFBEc4e45f0eBb2098698',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'rtv1',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'ethereum:strETH',
    },
  },
  {
    id: 'ethereum-reporting-test-vault-2',
    type: 'core-vault',
    name: 'Reporting Test Vault 2',
    description: '',
    category: 'core-vault',
    address: '0x515E3Cd72B6dd7c67D3bc624D98dDd3dEB71F7E3',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x515E3Cd72B6dd7c67D3bc624D98dDd3dEB71F7E3',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'rtv2',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'ethereum:strETH',
    },
  },
  {
    id: 'ethereum-reporting-test-vault-3',
    type: 'core-vault',
    name: 'Reporting Test Vault 3',
    description: '',
    category: 'core-vault',
    address: '0x7feee40bF19f82E5aF6032F6e152782eD15EA1a0',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x7feee40bF19f82E5aF6032F6e152782eD15EA1a0',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'rtv3',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
    callConfigOrigin: {
      branch: 'main',
      filenamePrefix: 'ethereum:strETH',
    },
  },
  {
    id: 'base-mellow-cb-test-vault',
    type: 'core-vault',
    name: 'Mellow Test Vault',
    description: 'Mellow Test Vault',
    category: 'core-vault',
    address: '0x375FE1860fe3fb5c680040490D0Cfb2760246f45',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
    network: 'base',
    networks: [
      {
        network: 'base',
        vaultAddress: '0x375FE1860fe3fb5c680040490D0Cfb2760246f45',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'CB-TV',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: false,
    },
  },
  {
    id: 'ethereum-test-flow-traders-vault',
    type: 'core-vault',
    name: 'test Flow Traders Vault',
    description: '',
    category: 'core-vault',
    address: '0x46c9690085281A7A0de404e9fcC0f7082aeD2336',
    curators: [],
    operator: [],
    points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
    network: 'ethereum',
    networks: [
      {
        network: 'ethereum',
        vaultAddress: '0x46c9690085281A7A0de404e9fcC0f7082aeD2336',
      },
    ],
    baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    lpTokenSymbol: 'tFTV',
    lpTokenDecimals: 18,
    oracleUpdateInterval: BigInt(86400),
    redeemHandlingInterval: BigInt(3600),
    allocations: {
      showAllocationsTab: true,
    },
  },
  ethereumTestKeyrock1,
  ethereumTestKeyrock2,
  ethereumTestKeyrock3,
  ethereumTestKeyrock3_2,
];
